import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import Switch from 'components/Switch'
import filterPanelStyles from 'components/Filters/FilterPanel/filter-panel.module.scss'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const SwitcherFilter = ({
  label = '',
  name,
  filterManager: { filters, updateFilter },
}) => {
  const { t } = useTranslation()
  const value = useMemo(() => filters[name], [filters])
  const { mds } = useBreakpoint()

  return (
    !mds && (
      <div className={filterPanelStyles['vat-switcher__container']}>
        <Switch
          label={t(label)}
          checked={value}
          onChange={() => {
            updateFilter({
              fieldName: name,
              value: !value,
            })
          }}
        />
      </div>
    )
  )
}

SwitcherFilter.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  filterManager: PropTypes.object,
}

export default SwitcherFilter
